import React, { useState, useEffect } from "react";
import { AppBar, Tabs, Tab } from "@material-ui/core";
import { useSelector, shallowEqual } from "react-redux";

function MultiTabBlock({ tabs, activeTab, onTabChange }) {
  const [tabIx, setTab] = useState(0);
  const languages = useSelector(
    (store) => store.authentication?.languages,
    shallowEqual
  );

  // useEffect para sincronizar activeTab externo con estado interno
  useEffect(() => {
    if (activeTab !== undefined && activeTab !== tabIx) {
      setTab(activeTab);
    }
  }, [activeTab, tabIx]);

  
  const handleChangeTabs = (_, newValue) => {
    setTab(newValue);
    // Si se proporciona onTabChange, llamarlo
    if (onTabChange) {
      onTabChange(newValue);
    }
  };

  if (!tabs)
    return <div> Loading... or an error occurred, please check your wifi </div>;

  return (
    <>
      <AppBar position="static" color="default" key="appbar">
        <Tabs
          value={tabIx}
          onChange={handleChangeTabs}
          variant="scrollable"
          scrollButtons="auto"
          key="tabs"
        >
          {tabs.map((tab, index) =>
            tab.enable ? <Tab key={index} label={tab.title} /> : null
          )}
        </Tabs>
      </AppBar>
      {tabs.map(
        (tab, index) =>
          tabIx === index && (
            <div key={`tabContainer-${index}`} className="mt-4">
              {tab.renderContent()}
            </div>
          )
      )}
    </>
  );
}

export default MultiTabBlock;
